import _ from 'lodash';
import { FormioCustomEvent } from 'src/core/Formio.types';
import { Router } from 'src/core/router/Router';
import {
    ComponentEventInstance,
    ProcessContextDefenition,
} from 'src/stores/ProcessStore/ProcessContextDefenition.util';
import { ProcessStoreProvider } from 'src/stores/ProcessStore/ProcessStore';

export const handleStartProcessCustomEvent = (
    // todo: implement to all StartProcessCustomEvents if possible
    event: FormioCustomEvent,
    url: string,
) => {
    const processKey = (event.component as any).properties?.processKey;

    const contextKey = (event.component as any).properties?.context;

    const process = ProcessStoreProvider.getInstance(processKey);

    const useContextWrapperValue = (event.component as any).properties
        ?.useContextWrapper;

    if (_.has(event.component.properties, 'useContextWrapper')) {
        const value = useContextWrapperValue !== 'false';
        process.setUseContextWrapper(value);
    }

    if (contextKey) {
        const context = ProcessContextDefenition(
            contextKey,
            event as ComponentEventInstance,
        );
        process.setContext(context);
    }

    Router.navigate(`${url}/process/${processKey}`);
};
